import { Component, Inject, OnInit } from '@angular/core';
import { CMPS_DIALOG_DATA } from '@cmps/ng-uikit';

import { useDispatcher } from '../../../store.decorator';

import { TranslationKeyMap } from './bl-dialog.i18n';
import { BlDialogService } from './bl-dialog.service';
import { BlDialogData } from './model/bl-dialog-data.model';
import { listDocuments } from './state/list-documents.action';

@Component({
    selector: 'cmps-coaching-bl-dialog',
    templateUrl: './bl-dialog.component.html',
    host: {
        class: 'cmps-coaching-bl-dialog',
    },
})
export class BlDialogComponent implements OnInit {
    /** @private */ _i18n = TranslationKeyMap;

    constructor(
        @Inject(CMPS_DIALOG_DATA) private readonly _data: BlDialogData,
        /** @private */ readonly _service: BlDialogService,
    ) {}

    ngOnInit(): void {
        useDispatcher(
            this._service,
            listDocuments({ focus: this._data.focus }),
        );
    }
}
